import {TranslateService} from '@ngx-translate/core';
import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorI18nCacheService} from '@tj/tj-dmp-lib-api';
import {Subscription} from 'rxjs';

@Component({
    selector: 'dmp-select-airline',
    templateUrl: './select-airline.component.html',
    styles: [':host { display: block; width: 100%; }'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SelectAirlineComponent),
        multi: true
    }],
    standalone: false
})
export class SelectAirlineComponent implements ControlValueAccessor, OnInit, OnDestroy {
    @Input() placeholder = this.translate.instant('invoicing.shared.airlines');
    options: {label: string; value: string}[] = [];
    value: string[] = [];
    disabled = false;
    loading = false;
    loadError = false;
    private request?: Subscription;
    private onChange: (value: string[]) => void = () => {};
    private onTouched: () => void = () => {};

    constructor(private readonly translate: TranslateService, private cacheI18n: ConfiguratorI18nCacheService) {}

    ngOnInit(): void {
        this.loadAirlines();
    }

    loadAirlines(): void {
        this.request?.unsubscribe();
        this.loading = true;
        this.loadError = false;
        this.request = this.cacheI18n.searchUsingGET('AIRLINE', true).subscribe({
            next: items => {
                this.options = (items || [])
                    .filter(item => item.key?.trim() && item.value?.trim())
                    .map(item => ({label: `${item.value.trim()} (${item.key.trim()})`, value: item.key.trim()}))
                    .sort((left, right) => left.label.localeCompare(right.label));
                this.loading = false;
            },
            error: () => {
                this.loading = false;
                this.loadError = true;
            }
        });
    }

    writeValue(value: string[] | null): void {
        this.value = Array.isArray(value) ? [...value] : [];
    }

    registerOnChange(fn: (value: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
    }

    setValue(value: string[] | null): void {
        if (this.disabled) { return; }
        this.writeValue(value);
        this.onChange(this.value);
        this.onTouched();
    }

    ngOnDestroy(): void {
        this.request?.unsubscribe();
    }
}
